import {
  type CmsMappedComponents,
  type CmsReferenceComponents,
  type ReferenceRenderProps,
} from '@/features/cms/components/CMS/types'
import dynamic from 'next/dynamic'

const DynamicAddressCheck = dynamic(
  async () => (await import('@/features/cms/components/CMS/components/AddressCheck')).AddressCheck,
)
const DynamicHeadlineImageCard = dynamic(
  async () =>
    (await import('@/features/cms/components/CMS/components/HeadlineImageCard')).HeadlineImageCard,
)
const DynamicHeadlineImageLink = dynamic(
  async () =>
    (await import('@/features/cms/components/CMS/components/HeadlineImageLink')).HeadlineImageLink,
)
const DynamicDisclaimer = dynamic(
  async () =>
    (await import('@/features/cms/components/CMS/components/CMSDisclaimer')).CMSDisclaimer,
)
const PartnershipBanner = dynamic(
  async () => (await import('./components/PartnershipBanner')).PartnershipBanner,
)
const DynamicPricingLinks = dynamic(
  async () => (await import('@/features/cms/components/CMS/components/PricingLinks')).PricingLinks,
)
const DynamicAppDownloadLinks = dynamic(
  async () =>
    (await import('@/features/cms/components/CMS/components/AppDownloadLinks')).AppDownloadLinks,
)
const DynamicCouponCodeSignupForm = dynamic(
  async () =>
    (await import('@/features/cms/components/CMS/components/CouponCodeSignupForm'))
      .CouponCodeSignupForm,
)
const DynamicRedeemEmailForm = dynamic(
  async () =>
    (await import('@/features/cms/components/CMS/components/Forms/RedeemEmailForm'))
      .RedeemEmailForm,
)
const DynamicSingleCTA = dynamic(
  async () => (await import('@/features/cms/components/CMS/components/SingleCTA')).SingleCTA,
)

export const referenceComponents: CmsMappedComponents<CmsReferenceComponents['content_type_id']> = {
  address_check: DynamicAddressCheck,
  app_download_links: DynamicAppDownloadLinks,
  coupon_code_signup_form: DynamicCouponCodeSignupForm,
  footer_disclaimer: DynamicDisclaimer,
  headline_image_card: DynamicHeadlineImageCard,
  headline_image_link: DynamicHeadlineImageLink,
  partnership_banner: PartnershipBanner,
  pricing_links: DynamicPricingLinks,
  redeem_email_form: DynamicRedeemEmailForm,
  single_cta: DynamicSingleCTA,
}

export const ReferenceRenderer = ({ references }: ReferenceRenderProps) => {
  if (!references) return null
  return (
    <>
      {references.map((item) => {
        if (item.content_type_id in referenceComponents) {
          const Component = referenceComponents[item.content_type_id]
          return <Component key={item.id} {...item} />
        }

        return null
      })}
    </>
  )
}
